<div class="heroes-container">
<!--    <app-slider-horizontal [elements]="articles" />-->
    <app-slider-horizontal
            *ngIf="!loading"
            [elements]="articles"
            [grid]="1"
            [step]="4"
            [backgroundContain]="false"
    />
</div>
